/**
 * Renders text with URLs converted to clickable links (opens in new tab).
 */
export function LinkifyText({ text, className }) {
  if (!text) return null;

  const urlRegex = /(https?:\/\/[^\s<]+)/g;
  const parts = text.split(urlRegex);

  return (
    <span className={className}>
      {parts.map((part, i) =>
        urlRegex.test(part) ? (
          <a
            key={`link-${i}-${part.slice(0, 20)}`}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-primary underline hover:text-primary/80 transition-colors"
            data-testid="linkified-url"
          >
            {part}
          </a>
        ) : (
          <span key={`text-${i}-${part.slice(0, 20)}`}>{part}</span>
        )
      )}
    </span>
  );
}
